import { useCallback, useState } from 'react';

import type { BgaPartnerInterest, QuestionnaireAnswers } from '@shared';

interface UsePartnerInterestQuestionOptions {
  initialValue: BgaPartnerInterest | null;
  submitWithoutAdvance: (patch: Partial<QuestionnaireAnswers>) => Promise<void>;
  advance: (patch?: Partial<QuestionnaireAnswers>) => void;
}

export interface PartnerInterestQuestionState {
  value: BgaPartnerInterest | null;
  confirmedValue: BgaPartnerInterest | null;
  select: (next: BgaPartnerInterest) => Promise<void>;
  confirm: () => void;
}

export function usePartnerInterestQuestion({
  initialValue,
  submitWithoutAdvance,
  advance,
}: UsePartnerInterestQuestionOptions): PartnerInterestQuestionState {
  const [value, setValue] = useState<BgaPartnerInterest | null>(initialValue);
  const [confirmedValue, setConfirmedValue] = useState<BgaPartnerInterest | null>(null);

  const select = useCallback(
    async (next: BgaPartnerInterest) => {
      setValue(next);
      await submitWithoutAdvance({ bga_partner_interest: next });
      setConfirmedValue(next);
    },
    [submitWithoutAdvance],
  );

  const confirm = useCallback(() => {
    if (!confirmedValue) return;
    setConfirmedValue(null);
    advance({ bga_partner_interest: confirmedValue });
  }, [confirmedValue, advance]);

  return { value, confirmedValue, select, confirm };
}
